(function(){
    'use strict';
    $('.table--detailed').each( function(i,table) {
        $(table).css('min-width','768px');
        $(table).wrap('<div style="overflow:auto"></div>');
    });
    
}());
